<template>
  <section>
    <b-modal :active.sync="OpenModalShowQuestions" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Encuesta</p>
        </header>
        <section class="modal-card-body">
          <h1 class="title is-4" style="display: flex;
    flex-direction: row;">
            <img src="\images\Logo-SSM.jpg" width="90"/>
            <div style="margin-left: 1em">Nombre de la Encuesta: {{Questionarie.name}}</div>
          </h1>
<!--          <div>-->
<!--            <img src="\images\foto_cosam.png" />-->
<!--          </div>-->
          <h2 class="content" v-html="Questionarie.description"></h2>
          <div class="box" v-for="Question in Questions" :key="Question.id">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <div v-html="Question.question"></div> ({{Question.type_selection_id}})
                </tr>
                <tr>
                  <div class="field buttons is-right" v-if="Questionarie.state=='Creada'">
                    <b-button
                      type="is-danger is-small"
                      @click="removeQuestion(Question.id)"
                      outlined
                    >Eliminar</b-button>
                    <b-button
                      type="is-info is-small"
                      @click="changeQuestion(Question.id,Question.question)"
                      outlined
                    >Editar</b-button>
                  </div>
                </tr>
              </thead>
            </table>

            <ul v-for="Answer in Question.questions_alternatives" :key="Answer.alternative.id">
              <li>{{Answer.alternative.alternative}}</li>
            </ul>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { getQuestionarie } from "../../../services/questionarie";
import {
  deleteQuestion,
  editQuestion,
  getQuestion,
} from "../../../services/question";

export default {
  props: ["OpenModalShowQuestions", "closeBasic", "questionarie_id"],
  data() {
    return {
      isLoading: false,
      Questionarie: {
        name: "",
        description: "",
      },
      Questions: [],
    };
  },
  created: function () {
    this.isLoading = true;
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.Questions = [];
      await getQuestionarie(this.$http, this.questionarie_id).then(
        (response) => {
          console.log("DATA:", response);
          this.Questionarie = response;
          response.questions.forEach((question) => {
            this.Questions.push({ ...question });
          });
          this.isLoading = false;
        }
      );
    },
    removeQuestion(id) {
      this.$buefy.dialog.confirm({
        title: "¿Desea Eliminar la Pregunta?",
        message:
          "Una vez eliminada la pregunta, tendra que ingresarla de nuevo en caso de ser necesario",
        confirmText: "Eliminar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          await deleteQuestion(this.$http, id).then(() => {
            this.toast("Eliminada", "is-danger");
            this.chargeData();
          });
        },
      });
    },
    changeQuestion(id, question) {
      console.log(id);
      this.$buefy.dialog.prompt({
        message: `Favor ingresar la pregunta`,
        inputAttrs: {
          placeholder: question,
        },
        cancelText: "Cerrar",
        confirmText: "Guardar",
        trapFocus: true,
        onConfirm: async (value) => {
          this.isLoading = true;
          await getQuestion(this.$http, id).then(async (response) => {
            let data = {
              ...response,
              question: value,
            };
            await editQuestion(this.$http, id, data).then(() => {
              this.toast("Editado", "is-success");
              this.chargeData();
            });
          });
        },
      });
    },
  },
};
</script>